import { render, staticRenderFns } from "./DeductiblesQuotatorNonProportional.vue?vue&type=template&id=42c578c8&scoped=true&"
import script from "./DeductiblesQuotatorNonProportional.vue?vue&type=script&lang=js&"
export * from "./DeductiblesQuotatorNonProportional.vue?vue&type=script&lang=js&"
import style0 from "./DeductiblesQuotatorNonProportional.vue?vue&type=style&index=0&id=42c578c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c578c8",
  null
  
)

export default component.exports